<template>
    <div class="Settlementledger-container">
        <el-date-picker v-model="searchYear" format="yyyy" value-format="yyyy" type="year" :clearable="false"
            placeholder="选择年" @change="dateChange">
        </el-date-picker>
        <div class="card-box">
            <template v-for="item in maxMonth">
                <el-card class="card-item" :key="item">
                    <div v-if="closedData[item] && closedData[item].length > 0"
                        :class="['state', closedData[item][0]['settlementStatus'] === '已结账' ? 'closed' : '']">{{
                        closedData[item][0]['settlementStatus'] || '未结账' }}</div>
                    <div class="title">{{ item }}月</div>
                    <div class="tools-box">
                        <el-button @click="gotoDetail(item)">查看明细</el-button>
                        <el-button
                            v-if="closedData[item] && closedData[item][0] && closedData[item][0]['settlementStatus'] === '未结账'"
                            type="primary" @click="confirmSettlement(item)">确认结账</el-button>
                    </div>
                    <div class="content">
                        <el-table :data="closedData[item]" border :header-cell-style="getTableHeader()" stripe>
                            <el-table-column :prop="item.prop" :label="item.label" :width="item.width"
                                v-for="item in tableHeader" :key="item.prop" align="center">
                            </el-table-column>
                        </el-table>
                    </div>
                </el-card>
                <template v-if="(item % 3) === 0 || item === maxMonth">
                    <el-card class="card-item" :key="'quarter' + item">
                        <div class="title">第{{ textMap[quarterMap[item]] }}季度</div>
                        <div class="tools-box">
                            <el-button @click="gotoDetail(quarterMap[item])">查看明细</el-button>
                        </div>
                        <div class="content">
                            <el-table :data="quarterData[quarterMap[item]] || []" border
                                :header-cell-style="getTableHeader()" stripe>
                                <el-table-column :prop="item.prop" :label="item.label" :width="item.width"
                                    v-for="item in tableHeader" :key="item.prop" align="center">
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-card>
                    <el-divider :key="'line' + item"></el-divider>
                </template>
            </template>
            <el-card class="card-item w100">
                <div class="title">{{ searchYear }}年度</div>
                <div class="content">
                    <el-table :data="yearData" border :header-cell-style="getTableHeader()" stripe>
                        <el-table-column :prop="item.prop" :label="item.label" :width="item.width"
                            v-for="item in tableHeader" :key="item.prop" align="center">
                        </el-table-column>
                    </el-table>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import { getTableHeader, formatDate } from '@/assets/js/common.js'
import { ajaxPost, Baseurl } from '../../../../api/api/api';
export default {
    name: 'Settlementledger',
    components: {},
    props: {},
    data() {
        return {
            searchYear: '',
            tableHeader: [
                { label: '币种', prop: 'currency', width: 68,},
                { label: '期初', prop: 'beginningBalance'},
                { label: '期末', prop: 'endingBalance'},
                { label: '账面利润', prop: 'bookProfit'},
                { label: '可用利润', prop: 'availableProfit'},
                { label: '账期利润', prop: 'accountPeriodProfit'},
                { label: '账期支出', prop: 'accountPeriodExpenditure'},
            ],
            quarterMap:{
                1: 'q1',
                2: 'q1',
                3: 'q1',
                4: 'q2',
                5: 'q2',
                6: 'q2',
                7: 'q3',
                8: 'q3',
                9: 'q3',
                10: 'q4',
                11: 'q4',
                12: 'q4',
            },
            textMap:{
                q1: '一',
                q2: '二',
                q3: '三',
                q4: '四',
            },
            maxMonth: 0,
            closedData:{}, //已结账数据
            quarterData:{}, //季度数据
            yearData:[], //年度数据
        };
    },
    watch: {},
    computed: {},
    created() {
        this.searchYear = formatDate(Date.now(), 'YYYY');
        this.maxMonth = +formatDate(Date.now(), 'MM');
    },
    mounted() {
        this.setDomMargin();
        this.getData();
    },
    methods: {
        getTableHeader,
        gotoDetail(month){
            let startDate = '';
            let endDate = '';
            if(isNaN(month)){
                const arr = [];
                for (let m1 in this.quarterMap){
                    if(this.quarterMap[m1] === month){
                        arr.push(+m1);
                    }
                }
                let s = Math.min(...arr);
                let e = Math.max(...arr);
                const s_mm = (+s + '').padStart(2, '0');
                const e_day = new Date(+this.searchYear, +e, 0).getDate();
                const e_mm = (+e + '').padStart(2, '0');
                startDate = this.searchYear + '-' + s_mm + '-01';
                endDate = this.searchYear + '-' + e_mm + '-' + e_day;
            }else{
                const day = new Date(+this.searchYear, +month, 0).getDate();
                const m = +month + '';
                const mm = m.padStart(2, '0')
                startDate = this.searchYear + '-' + mm + '-01';
                endDate = this.searchYear + '-' + mm + '-' + day;
            }
            this.$router.push({
                name: 'IncomeExpenditureDetails',
                params: {
                    startDate: startDate,
                    endDate: endDate,
                    searchDateType: 'tradingTime',
                }
            })
        },
        setDomMargin(){
            const cardItems = document.querySelectorAll('.card-item');
            cardItems.forEach((item, index) => {
                if (index % 2 === 0) {
                    item.classList.add('odd-card-item');
                }
            });
        },
        dateChange(){
            if (+this.searchYear < +formatDate(Date.now(), 'YYYY')){
                this.maxMonth = 12;
            } else if (this.searchYear == +formatDate(Date.now(), 'YYYY')){
                this.maxMonth = +formatDate(Date.now(), 'MM');
            }else{
                // this.$message.error
            }
            this.getData();
        },
        async getData(){
            const allPro = [];
            for (let i = 1; i <= this.maxMonth; i++) {
                const params = {
                    year: +this.searchYear,
                    month: i,
                };
                const timestamp = new Date().getTime() + Math.random().toString(); // 添加时间戳
                const pro = ajaxPost(Baseurl + 'incomeExpenditureLedgerController/selectIncomeExpenditureLedgerList?_t=' + timestamp, params).then((resp)=>{
                    if (resp.status === 200 && resp.data.code === 200) {
                        const res = resp.data.data;
                        this.$set(this.closedData, i, res)
                    }
                })
                allPro.push(pro);
            }
            Promise.all(allPro).then(()=>{
                const quarterData = {};
                const yearData = {};
                for(let m in this.closedData){
                    const d = this.closedData[m] || [];
                    if (!quarterData[this.quarterMap[+m]]){
                        quarterData[this.quarterMap[+m]] = {};
                    }
                    for(let i = 0; i < d.length; i++){
                        const currency = d[i]['currency'];
                        if (!quarterData[this.quarterMap[+m]][currency]){
                            quarterData[this.quarterMap[+m]][currency] = {};
                        }
                        if (!yearData[currency]){
                            yearData[currency] = {};
                        }
                        for(let k in d[i]){
                            if (k === 'currency') continue
                            if (!quarterData[this.quarterMap[+m]][currency][k]){
                                quarterData[this.quarterMap[+m]][currency][k] = 0;
                            }
                            quarterData[this.quarterMap[+m]][currency][k] += (d[i][k] ? +d[i][k] : 0);

                            if (!yearData[currency][k]) {
                                yearData[currency][k] = 0;
                            }
                            yearData[currency][k] += (d[i][k] ? +d[i][k] : 0);
                        }
                    }
                }
                const result = {};
                for(let k in quarterData){
                    const arr = [];
                    for (let currency in quarterData[k]){
                        for (let key in quarterData[k][currency]){
                            quarterData[k][currency][key] = isNaN(quarterData[k][currency][key]) ? 0 : +(+quarterData[k][currency][key]).toFixed(2);
                        }
                        arr.push({
                            ...quarterData[k][currency],
                            currency,
                        })
                    }
                    result[k] = arr;
                }
                this.quarterData = result;

                const yearResult = [];
                for(let k in yearData){
                    for (let key in yearData[k]) {
                        yearData[k][key] = isNaN(yearData[k][key]) ? 0 : +(+yearData[k][key]).toFixed(2);
                    }
                    yearResult.push({
                        ...yearData[k],
                        currency: k,
                    })
                }
                this.yearData = yearResult;
            })
        },
        confirmSettlement(month){
            const params = {
                year: +this.searchYear,
                month: month
            }
            ajaxPost(Baseurl + 'incomeExpenditureLedgerController/confirmSettlement', params).then((response)=>{
                if (response.status === 200 && response.data.code === 200){
                    this.$message.success('修改成功');
                    this.getData();
                }
            })
        },
    },
    
};
</script>
<style lang="scss" scoped>
.Settlementledger-container{
    background-color: #f0f2f5;
    padding: 20px;
    box-sizing: border-box;
    .card-box{
        margin-top: 10px;
        .card-item{
            display: inline-block;
            width: calc((100% - 10px) / 2);
            background-color: #fff;
            margin-bottom: 10px;
            // margin-right: 10px;
            box-sizing: border-box;
            border-radius: 10px;
            position: relative;
            /* 为绝对定位的“未结账”标签做准备 */
            padding: 16px;
            /* 可根据需求调整内边距 */
            box-sizing: border-box;
            /deep/ .el-card__body{
                padding: 0;
            }
            &.w100{
                width: 100%;
                margin: 0;
            }
            &.odd-card-item {
                margin-right: 10px;
            }
            .tools-box{
                position: absolute;
                right: 16px;
                top: 16px;
            }
            .state {
                position: absolute;
                top: 17px;
                left: -25px;
                background-color: #4086ff;
                /* 蓝色，可根据需求修改 */
                color: #fff;
                /* 白色文字 */
                padding: 4px 8px;
                transform: rotate(-45deg);
                /* 旋转并调整位置，实现斜角标签效果 */
                font-size: 12px;
                width: 100px;
                text-align: center;
            }
            .closed{
                background-color: #67C23A;
            }
            .title {
                font-size: 20px;
                line-height: 60px;
                font-weight: 500;
                /* 月份文字大小，可调整 */
                text-align: center;
                /* 让月份居中显示，可根据需求调整 */
            }
        }
    }
}
/deep/ .el-table__empty-text{
    line-height: 23px !important;
}
/deep/ .el-table__empty-block{
    padding: 12px 0;
    min-height: auto !important;
}
</style>